import styled from "styled-components";

export const StyledRootWrapper = styled.div`
    position: relative;
    height: 100vh;
    margin: auto;
    display: block;
    background: #E4EBFF;
`
